// @flow
import AddCategory from './AddCategory';

export default AddCategory;
